// extracted by mini-css-extract-plugin
module.exports = {"BasicInfoSection":"BasicInfoSection_BasicInfoSection__3cUqq","Title":"BasicInfoSection_Title__Z6xep","Content":"BasicInfoSection_Content__1RmW8"};